import { NgModule } from '@angular/core';
import { IfFeatureDirective } from './if-feature.directive';
import { FeatureFlagService } from './feature-flag.service';

@NgModule({
  providers: [FeatureFlagService],
  declarations: [IfFeatureDirective],
  exports: [IfFeatureDirective],
})
export class FeatureFlagsModule {}
